module.exports = __webpack_public_path__ + "6f31db3931a3528fe3ae00fff428793e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/impact_shares.png
// module id = 1801
// module chunks = 0